export default [
  '+380 (97) 811-35-44',
  '+380 (67) 159-68-03',
  '+380 (93) 617-08-51',
  '+380 (97) 811-35-45',
  '+380 (97) 811-35-44',
  '+380 (99) 345-21-03',
];
